import axios from "axios";
import type { Story } from "@theirstory/common/api_types/backend";

import { isStoryPlaybackReady } from "../../Hub/utils/utils";

export const DEFAULT_INDEX_SYSTEM_PROMPT = "You are a writer that creates indexes";
export const DEFAULT_INDEX_USER_PROMPT = `Please create an index for this interview. 
Each chapter of the index should contain: 
1) a timecode signifying the start of the chapter. The timecode should have hours, minutes and seconds, not milliseconds.; 
2) a title for the chapter; 
3) a summary of the chapter;
4) keywords separated by commas. 
I want a  JSON object with an array of chapter  with the  attributes`;

export const DEFAULT_SUMMARY_SYSTEM_PROMPT = "You are a writer that creates summaries";
export const DEFAULT_SUMMARY_USER_PROMPT =
  "Do not mention the messages and treat them as a whole. The messages constitute the transcript of a recording, which is most likely an interview. The summary should give a researcher a general overview of the key topics discussed in the recording, so that the researcher can decide wheter or not the recording is relevant to their research. The summary should be no more than 100 words, although it can be less.";

export const isStoryEligibleForAIGeneration = (story: Story) =>
  story.transcript === "completed" && isStoryPlaybackReady(story);

export const getEligibleAIStoryIds = (stories: Story[]) =>
  stories.filter(isStoryEligibleForAIGeneration).map((story) => story._id);

export const requestIndexGeneration = async (storyId: string, prompts?: { system: string; user: string } | null) => {
  if (prompts) {
    const data = JSON.stringify(prompts);
    return axios.get(`/transcripts/${storyId}/chatgpt_index?prompts=${data}`);
  }

  return axios.get(`/stories/${storyId}/speechmatics/autochaptering`);
};

export const requestSummaryGeneration = async (storyId: string, prompts?: { system: string; user: string } | null) => {
  if (prompts) {
    const data = JSON.stringify(prompts);
    return axios.get(`/transcripts/${storyId}/chatgpt_summary?prompts=${data}`);
  }

  return axios.get(`/transcripts/${storyId}/chatgpt_summary`);
};

export const requestClipSummaryGeneration = async (storyId: string, clipId: string) =>
  axios.get(`/stories/${storyId}/generate_clip_description/${clipId}`);
